module.exports = __webpack_public_path__ + "static/media/background-desktop.c6165747.jpg";